import { bool, func, node, number, string } from "prop-types";
import { createContext, useContext, useMemo, useRef, useState } from "react";

import { useGetNetworkMetadata, useGetUserData } from "Flocknote/API/queries";

import useIsWiderThan from "Utilities/Hooks/useIsWiderThan";

import { contentKeys } from "./contentKeys";

const MemberToolbarContext = createContext();
/**
 *
 * @returns {MemberToolbarContext}
 */
const useMemberToobarContext = () => useContext(MemberToolbarContext);

const MemberToolbarState = ({
  onAuthChange,
  loginVariant,
  tabID,
  accentColor,
  logoutGoesToLogin,
  isDark,
  children,
  contextInquiryText,
  languageForLoggedOut,
  bottomOffset,
}) => {
  const { isLoading: isLoadingGetUserData } = useGetUserData();
  const { isLoading: isLoadingGetMetaData } = useGetNetworkMetadata();

  const [activeContentKey, setActiveContentKey] = useState(contentKeys.nothing);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [message, setMessage] = useState("");
  const [generalInquiry, setGeneralInquiry] = useState(false);
  const [flocknoteSupport, setFlocknoteSupport] = useState(false);
  const [prayerRequest, setPrayerRequest] = useState(false);
  const [clickAwayDisabled, setClickAwayDisabled] = useState(false);
  const [formWasActive, setFormWasActive] = useState(false);
  const wrapperRef = useRef();
  const remoteCancelLoginRef = useRef();
  const contactButtonRef = useRef();
  const userButtonRef = useRef();
  const loginButtonRef = useRef();
  const sendButtonRef = useRef();
  const backButtonRef = useRef();

  const isThin = !useIsWiderThan(wrapperRef, { px: 360 });

  const isIniting = useMemo(() => {
    return isLoadingGetUserData || isLoadingGetMetaData;
  }, [isLoadingGetUserData, isLoadingGetMetaData]);

  return (
    <MemberToolbarContext.Provider
      value={{
        onAuthChange,
        loginVariant,
        tabID,
        accentColor,
        logoutGoesToLogin,
        contextInquiryText,
        languageForLoggedOut,
        bottomOffset,
        activeContentKey,
        setActiveContentKey,
        isLoggingOut,
        setIsLoggingOut,
        message,
        setMessage,
        generalInquiry,
        setGeneralInquiry,
        flocknoteSupport,
        setFlocknoteSupport,
        prayerRequest,
        setPrayerRequest,
        clickAwayDisabled,
        setClickAwayDisabled,
        formWasActive,
        setFormWasActive,
        isIniting,
        isDark,
        isThin,
        wrapperRef,
        remoteCancelLoginRef,
        contactButtonRef,
        userButtonRef,
        loginButtonRef,
        sendButtonRef,
        backButtonRef,
      }}
    >
      {children}
    </MemberToolbarContext.Provider>
  );
};

MemberToolbarState.propTypes = {
  onAuthChange: func,
  loginVariant: string,
  tabID: string,
  accentColor: string,
  children: node,
  logoutGoesToLogin: bool,
  isDark: bool,
  contextInquiryText: string,
  languageForLoggedOut: bool,
  bottomOffset: number,
};

export { MemberToolbarState, useMemberToobarContext };
